import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { DsSwbAccessoriesQtyIP, MultiOptDetails_4DS, SaveEventType, SaveStatusObj, SOModule, UserType, ValidationItem, ValidationSummary } from '../../../../shared/misc-classes';
import { DataService } from '../../../../shared/dataservice.service';
import { ValidationDialog } from '../../../../dialogs/validation-dialog/validation-dialog';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';

@Component({
  selector: 'ds-swb-acc-qty',
  templateUrl: './ds-swb-acc-qty.component.html',
  styleUrls: ['./ds-swb-acc-qty.component.css']
})
export class DsSwbAccQtyComponent implements OnInit, OnChanges {
  
    @Input() dsSwbAccQtyObj: DsSwbAccessoriesQtyIP;
    @Input() soLockObtained:boolean;
    @Input() accessLevel: Array<UserType>;
    @Output() updateDatasheet: EventEmitter<SaveStatusObj> = new EventEmitter();
    
    disableForm: boolean = false;
    inputDisableMessage: string = 'This form is not yet enabled';
    readonlyAccess : boolean = false;
    Hvr:any = {};
    hasAccessEE: boolean = false;
    hasAccessME: boolean = false;
    hasAccessPM: boolean = false;
    lockFields: boolean = false; // After HOM lock
    hasActionPlanAccess: boolean = false;

    swbSpecialReqDetEditable: boolean = false;
    swbSpecialReqDetApplicable: boolean = false;

  
    constructor(public _dataService: DataService, public dialog: MatDialog) { }
  
    ngOnInit(): void {
    }
    ngOnChanges(): void {
       this.disableForm = true;
      if(this.soLockObtained == false){
        this.inputDisableMessage = "You can't Edit";
      }
      else if (this.accessLevel.includes(this._dataService.userType) == false) {
        this.inputDisableMessage = "You don't have EDIT ACCESS.";
      }
      else {
        this.disableForm = false;
        // this.checkUserEnabled();
      }
      if(this._dataService.hasReadOnlyAccess){
        this.readonlyAccess = true;
      }
      this.hasAccessEE = this._dataService.userType === (UserType.ELECTRICAL_ENGINEERING) || this._dataService.userType === (UserType.MARKETING) || this._dataService.userType === (UserType.SUPER_ADMIN);
      this.hasAccessME = this._dataService.userType === (UserType.MECHANICAL_ENGINEERING) || this._dataService.userType === (UserType.MARKETING) || this._dataService.userType === (UserType.SUPER_ADMIN);
      this.hasAccessPM = this._dataService.userType === (UserType.PROJECT_MANAGEMENT) || this._dataService.userType === (UserType.MARKETING) || this._dataService.userType === (UserType.SUPER_ADMIN);
      this.hasActionPlanAccess = this._dataService.userType === (UserType.PROJECT_MANAGEMENT) || this._dataService.userType === (UserType.MARKETING) || this._dataService.userType === (UserType.SUPER_ADMIN)||
      this._dataService.userType === (UserType.MECHANICAL_ENGINEERING) || this._dataService.userType === (UserType.ELECTRICAL_ENGINEERING) || this._dataService.userType === (UserType.C30_ENGINEERING) || this._dataService.userType === (UserType.PLANNING_PRODUCTION) ||
      this._dataService.userType === (UserType.PLANNING) || this._dataService.userType === (UserType.TESTING) || this._dataService.userType === (UserType.STORES) || this._dataService.userType === (UserType.LOGISTICS) || this._dataService.userType === (UserType.SCM) || this._dataService.userType === (UserType.PURCHASE) || this._dataService.userType === (UserType.PRODUCTION);
      if (!this.dsSwbAccQtyObj.parentSORef.isDatasheetSubOrderEnabled) {
        this.lockFields = false;
      }
      else {
        this.lockFields = true;
      }
  
    }

    filterSpecReq(){
      let _options :Array<string> = [];
      _options.push('Cable Termination Kit');
      if(this.dsSwbAccQtyObj.parentDSRef.dataSheetType.includes('ZS2')){
         let _idx = this.dsSwbAccQtyObj.parentDSRef.dsCurrentTrafoIP.ctMould.findIndex(ct => ct.type3 == '001');
         if(_idx != -1){
            _options.push('CBCT');
         }
      }
      let _cbRun = this.dsSwbAccQtyObj.parentDSRef.dsPanelIP.feederRatingBreakerPan.findIndex(cr => cr.type1 == '006'); // Cable Run should have 'Contactor' for adding this option
      if(_cbRun != -1){
        _options.push('Fuse Puller');
      }

      _options.push('Combiflex Lug');
      _options.push('Others');
      return _options;
    }

    swbSpecialReqChange(selectedValue: string){
      switch(selectedValue){
        case 'Cable Termination Kit': // Cable Termination Kit
          this.dsSwbAccQtyObj.swbSpecialReqDetails = 'Note : Release with PI in C40';
          this.swbSpecialReqDetEditable = true;
          this.swbSpecialReqDetApplicable = false;
          break;
        case 'CBCT': // CBCT
          this.dsSwbAccQtyObj.swbSpecialReqDetails = 'To be release in SWBD';
          this.swbSpecialReqDetEditable = true;
          this.swbSpecialReqDetApplicable = false;
          break;
        case 'Fuse Puller': // Fuse Puller
          this.dsSwbAccQtyObj.swbSpecialReqDetails = '';
          this.swbSpecialReqDetEditable = false;
          this.swbSpecialReqDetApplicable = false;
          
          break;
        case 'Combiflex Lug': // Combiflex Lug
          this.dsSwbAccQtyObj.swbSpecialReqDetails = 'Note : Select if Combiflex Relay to be offered';
          this.swbSpecialReqDetEditable = true;
          this.swbSpecialReqDetApplicable = false;
          break;
        case 'Others': // Others
          this.dsSwbAccQtyObj.swbSpecialReqDetails = '';
         this.swbSpecialReqDetEditable = true;
          this.swbSpecialReqDetApplicable = true;
          break;

          default:
            this.dsSwbAccQtyObj.swbSpecialReqDetails = '';
            this.swbSpecialReqDetEditable = false;
            this.swbSpecialReqDetApplicable = false;
          break;
      }
    }

    
  addPointsBlock() {
      this.dsSwbAccQtyObj.addPointsDS(new MultiOptDetails_4DS("", "", "", ""));
    }
    removePointsBlock(_tsDS: MultiOptDetails_4DS) {
      if (_tsDS) {
        this.dsSwbAccQtyObj.removePointsDS(_tsDS);
      }
    }
   
 sectionNoteChangePM(_event: any) {
    this.dsSwbAccQtyObj.sectionNotePM = _event.target.value;
  }
  sectionNoteChangeEE(_event: any) {
    this.dsSwbAccQtyObj.sectionNoteEE = _event.target.value;
  }
  sectionNoteChangeME(_event: any) {
    this.dsSwbAccQtyObj.sectionNoteME = _event.target.value;
  }
  saveDS(_submitToNextSection:boolean){
      if(this.updateDatasheet){
        this.updateDatasheet.emit(new SaveStatusObj(SOModule.Marketing, 
            (_submitToNextSection == true ? SaveEventType.Submit_To_Next:SaveEventType.Save_Data)));
      }
    }
    reloadData(){
      if(this.updateDatasheet){
        this.updateDatasheet.emit(new SaveStatusObj(SOModule.Marketing, SaveEventType.Reload_Data));
      }
    }

  showSoValidation() {
    let _validList: Array<ValidationItem> = [];

    if (this.hasAccessME) {
      _validList.push(
        new ValidationItem("Panel Key", !!this.dsSwbAccQtyObj.swbPanelKey, " required to save Datasheet."),
        new ValidationItem("Breaker Rack In/Out", !!this.dsSwbAccQtyObj.swbBreakerRackInOut, " required to save Datasheet.")
      );
      if (this.dsSwbAccQtyObj.isEarthSwtHandleApplicable) {
        _validList.push(new ValidationItem("Earth Switch Handle", !!this.dsSwbAccQtyObj.swbEarthSwtHandle, " required to save Datasheet."));
      }
      if (this.dsSwbAccQtyObj.isBreakerServiceTrolleyApplicable) {
        _validList.push(new ValidationItem("Breaker Service Trolley", this.dsSwbAccQtyObj.swbBreakerServiceTrolley != null, " required to save Datasheet."));
      }
      _validList.push(
        new ValidationItem("PT Ramp", !!this.dsSwbAccQtyObj.swbPTRamp, " required to save Datasheet."),
        new ValidationItem("ME Note", !!this.dsSwbAccQtyObj.sectionNoteME, " required to save Datasheet.")
      );
    }
    if (this.hasAccessEE) {
      if (this.dsSwbAccQtyObj.isRelayTestApplicable) {
        _validList.push(new ValidationItem("Relay Test", this.dsSwbAccQtyObj.swbRelayTest != null, " required to save Datasheet."));
      }
      _validList.push(
        new ValidationItem("Special Requirement", !!this.dsSwbAccQtyObj.swbSpecialReq, " required to save Datasheet.")
      );
      if (this.swbSpecialReqDetApplicable) {
        _validList.push(new ValidationItem("Special Requirement Details", !!this.dsSwbAccQtyObj.swbSpecialReqDetails, " required to save Datasheet."));
      }
      _validList.push(new ValidationItem("EE Note", !!this.dsSwbAccQtyObj.sectionNoteEE, " required to save Datasheet."));
    }
    if (this.hasAccessPM) {
      _validList.push(new ValidationItem("PM Note", !!this.dsSwbAccQtyObj.sectionNotePM, " required to save Datasheet."));
    }

    let vSummaryObj: ValidationSummary = new ValidationSummary("Validation Summary.", _validList);
    this.dialog.open(ValidationDialog, { width: '50%', data: vSummaryObj });
  }

  saveSOValidation(): boolean {
    if (this.hasAccessME) {
      if (!this.dsSwbAccQtyObj.swbPanelKey || !this.dsSwbAccQtyObj.swbBreakerRackInOut ||
        !this.dsSwbAccQtyObj.swbPTRamp || !this.dsSwbAccQtyObj.sectionNoteME) {
        return false;
      }
      if (this.dsSwbAccQtyObj.isEarthSwtHandleApplicable && !this.dsSwbAccQtyObj.swbEarthSwtHandle) return false;
      if (this.dsSwbAccQtyObj.isBreakerServiceTrolleyApplicable &&
        this.dsSwbAccQtyObj.swbBreakerServiceTrolley == null) return false;
    }
    if (this.hasAccessEE) {
      if (!this.dsSwbAccQtyObj.swbSpecialReq || !this.dsSwbAccQtyObj.sectionNoteEE) return false;
      if (this.dsSwbAccQtyObj.isRelayTestApplicable &&
        this.dsSwbAccQtyObj.swbRelayTest == null) return false;
      if (this.swbSpecialReqDetApplicable && !this.dsSwbAccQtyObj.swbSpecialReqDetails) return false;
    }
    if (this.hasAccessPM) {
      if (!this.dsSwbAccQtyObj.sectionNotePM) return false;
    }
    return true;
  }
}

